import { render, staticRenderFns } from "./PinRegistration.vue?vue&type=template&id=6617cfd6&"
import script from "./PinRegistration.vue?vue&type=script&lang=js&"
export * from "./PinRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports